import { FC, useState } from 'react'
import { SequenceMenuItem } from '@sequencehq/core-components'
import { RecalculateCreditNoteDialog } from 'CreditNotes/components/dialog/RecalculateCreditNoteDialog'

type Props = {
  creditNoteId: string
  onClose: () => void
  onInvoiceCreated: (createdInvoiceId: string) => void
}

export const RecalculateCreditNoteMenuItem: FC<Props> = ({
  creditNoteId,
  onClose,
  onInvoiceCreated
}) => {
  const [showDialog, setShowDialog] = useState(false)

  return (
    <>
      <SequenceMenuItem
        uuid="recalculate-credit-note"
        data-testid={`creditNotes.${creditNoteId}.menuItem.recalculate`}
        label="Recalculate credit note"
        onClick={e => {
          e.stopPropagation()
          setShowDialog(true)
        }}
      />
      {showDialog && (
        <RecalculateCreditNoteDialog
          creditNoteId={creditNoteId}
          isOpen
          onClose={() => {
            setShowDialog(false)
            onClose()
          }}
          onInvoiceCreated={createdInvoiceId => {
            setShowDialog(false)
            onClose()
            onInvoiceCreated(createdInvoiceId)
          }}
        />
      )}
    </>
  )
}
